'use client'

import { Button } from '@/components/ui/button'
import firestore from '@/lib/firestore'
import { useEffect } from 'react'

export default function Error({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {
    useEffect(() => {
        firestore.log({
            user: '',
            createdDate: new Date(),
            error: JSON.stringify({
                message: error.message,
                stack: error.stack,
                digest: error.digest,
                url: window.location.href,
                ua: navigator.userAgent,
            })
        })
    }, [error])

    return (
        <div className='flex items-center justify-center p-8 h-[100vh]'>
            <div className='text-center flex flex-col gap-2'>
                <h2>Algo no salió bien.</h2>
                <Button onClick={() => location.reload()}>Inténtalo de nuevo</Button>
            </div>
        </div>
    )
}
